<template>
  <div class="yimiao">
    <div>
      <div>
        <van-cell-group >
          <van-field
            required
            v-model="datafrom.typeName"
            @click="fuwushow = true"
            readonly="readonly"
            label="求助类型"
            placeholder="请选择求助类型"
          />
          <van-popup v-model="fuwushow" position="bottom" get-container="body">
            <van-picker
              show-toolbar
              :columns="typeList"
              value-key="name"
              @cancel="fuwushow = false"
              @confirm="onfuwushow"
            >
            </van-picker>
          </van-popup>
        </van-cell-group>
        <!-- 标题信息 -->
        <van-cell-group>
          <van-field v-model="datafrom.address" required label="地点" placeholder="请输入地点" />
        </van-cell-group>

        <div style="margin-top: 15px;">
          <span style="font-size: 14px; color: #333; margin: 0 17px">图片</span>
          <div>
            <van-uploader v-model="fileList"  class="imgActivity" :max-count="1"  :after-read="afterRead"
            :deletable="true" @delete="shanchu" style="margin: 15px 18px 0" />
          </div>
        </div>
        <!-- 富文本编辑器 -->
        <div class="submit" style="padding: 10px 7px" >
          <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
          <span style="color: #646566; font-size: 14px">内容</span>
        </div>
        <div style="width:90%;margin:auto;" required>
          <Editor :value.sync="datafrom.content" />
        </div>
      </div>
      <!-- <div class="buttons">
            <van-button type="info" @click="postfrom()">提交</van-button>
          </div> -->

      <div class="buttons">
        <van-button type="info" style="margin: 10px 0" @click="postfrom(1)">提交</van-button>
        <van-button style="border: 1px solid #e6e6e6; margin: 10px 0" type="
              default" @click="fanhui()">返回</van-button>
      </div>
    </div>
  </div>
</template>
  <script>
  import Vue from 'vue'
  import { Dialog } from 'vant'
  import { Toast } from 'vant'
  import { getOpenId } from '@/utils/auth'
  Vue.use(Toast)
  import { addAssistance,getAssistance,listType } from '@/api/Changan-zhsq/ResidentsHelp'
  import Editor from '../../shop/Editor/index' // 富文本编辑器
import axios from "axios";
import config from "@/config";
  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
      Editor
    },
    data() {
      return {
        datafrom: {
          typeName: '',
          phone: '', // 手机、
          // 新增的字段
          content:'',//富文本内容
          title:'',//标题
      img: ''
        },
        fileList: [],
        uploadImgs: [],
        typeList: [],
        fuwushow:false
      }
    },
    created() {
      this.openId = this.$route.query.openid
      if(this.$route.params.id && this.$route.params.id!='null' && this.$route.params.id!='undefined'){
        this.wxGetPromotion()
      }else{
        this.$route.params.id = ''
      }
      this.getTypeFun()
    },
  
    methods: {
      getTypeFun() {
      listType(
        {
          page: 1,
          limit: 9999,
        }
      ).then(response => {
        this.typeList = response.data.data;
      });
    },
       // 动态类型选择器
       onfuwushow(val) {
      console.log(val);
      this.datafrom.typeId = val.id;
      this.datafrom.typeName = val.name;
      this.fuwushow = false;
    },
      wxGetPromotion() {
      console.log(this.$route.params.id);
      this.goodsid = this.$route.params.id;
      this.fileList = []
      getAssistance(this.goodsid).then((res) => {
        console.log(res);
        this.datafrom = res.data.data;
        if(res.data.data.img){
          this.fileList.push(
          {
            url:res.data.data.img
          }
        )
        }
        console.log(this.datafrom, "this.details");
        // this.getshoppingList(this.orderid);
      });
    },
      // 提交
      postfrom: function(row) {
        console.log(this.datafrom, 'dzx123123')
          if (this.datafrom.address == '') {
            Toast.fail('请输入标题')
            return false
          }
          if (this.datafrom.content == '') {
            Toast.fail('请输入内容')
            return false
          }
          if (this.datafrom.typeId == '') {
            Toast.fail('请选择求助类型')
            return false
          }
          this.datafrom.status = 0
        this.datafrom.openId =  this.$route.query.openid
        if( this.$route.params.id && this.$route.params.id!='null'){
          this.datafrom.id =  this.$route.params.id
        }
        // this.datafrom.WorkTime = this.WorkTime.join("-");
        // this.datafrom.IsMonitor = Number(this.datafrom.IsMonitor);
        addAssistance(this.datafrom).then((res) => {
            if (res.data.code == 0) {
              console.log(this.datafrom, 'dzx1234567890')
              console.log(res.data)
              Dialog.alert({
                title: '提示',
                message: '提交成功!',
              }).then(() => {
                if (window.__wxjs_environment === "miniprogram") {
                   window.wx.miniProgram.navigateBack({
                        delta:1
                    });
                 } else {
                  this.$router.go(-1)
                }
             
                // this.$router.push({
                //   name: "register",
                // });
              })
            } else {
              Dialog.alert({
                title: '提示',
                message: '提交失败!' + res.data.msg,
              }).then(() => {
                // this.datafrom.IsMonitor = this.datafrom.IsMonitor + "";
                // on close
              })
            }
          })
      },
      fanhui: function() {
        if (window.__wxjs_environment === "miniprogram") {
                   window.wx.miniProgram.navigateBack({
                        delta:1
                    });
                 } else {
                  this.$router.go(-1)
                }
      },
          // 图片上传
    afterRead(file) {
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          var arr = this.uploadImgs;
          arr.push(res.data.msg);
          this.uploadImgs = arr;
        }
        this.datafrom.img = this.uploadImgs + "";
      });
    },
    // 图片删除
    shanchu: function (file, detail) {
      this.uploadImgs.splice(detail.index, 1);
      this.datafrom.img = this.uploadImgs + "";
    },
      dateformat(val) {
        // 时间格式化事件 yy-mm-dd
        // let year = val.getFullYear();
        // let month = val.getMonth() + 1;
        // let day = val.getDate();
        let houser = val.getHours()
        let Minutes = val.getMinutes()
        if (month >= 1 && month <= 9) {
          month = `0${month}`
        }
        if (day >= 1 && day <= 9) {
          day = `0${day}`
        }
        if (houser >= 1 && houser <= 9) {
          houser = `0${houser}`
        }
        if (Minutes >= 1 && Minutes <= 9) {
          Minutes = `0${Minutes}`
        }
        // return `${year}-${month}-${day} ${houser}:${Minutes}`;
        return `${year}-${month}-${day}`
      },
    },
    
  }
  </script>
<style>
.imgs {
  margin: 0 15px;
}

.yimiao .inputFrom {
  margin: 15px 8%;
}

.yimiao .inputFrom input {
  width: 80%;
  margin: 8px 8%;
  padding: 8px 5px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
}

.yimiao .buttons {
  text-align: center;
}

.yimiao .buttons button {
  width: 90%;
  margin: 25px 5%;
  border-radius: 10px;
}

.buttons {
  text-align: center;
}

.buttons button {
  margin: 25px 10px;
  border-radius: 10px;
}

.imgActivity {
  vertical-align: middle;
}
.imgActivity .van-uploader__upload{
  border: 1px dashed #ccc;
}
</style>
  